import styled from "styled-components";

export const StyledQuestionReadyActions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 16px;
  max-width: 320px;
  margin-left: auto;
  margin-right: auto;

  .action-button {
    width: 130px;
    height: 30px;
    border: none;
    border-radius: 100px;
    padding: 0 10px;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: -0.22px;
    text-align: center;
    vertical-align: middle;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .button-icon {
    width: 12px;
    height: 12px;
    object-fit: contain;

    &.loading {
      animation: spin 1s linear infinite;
    }
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .export-button {
    background: #004ef7;
    color: #ffffff;
  }

  .background-button {
    background: #004ef7;
    color: #ffffff;
  }

  .video-button,
  .voice-button {
    background: #004ef7;
    color: #ffffff;
  }
`;
